import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import {  GuestLogin, StaffLogin, UserCredential } from "../../types/response";
import { loginCredentialGuest, loginCredentialStaff } from "../../initial-state/initial-state";

export interface AuthState {
    userCredentials: UserCredential | null,
    loginCredentialGuest: GuestLogin,
    loginCredentialStaff: StaffLogin
}

const initialState: AuthState = {
    userCredentials: null,
    loginCredentialGuest: loginCredentialGuest,
    loginCredentialStaff: loginCredentialStaff
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoginCredential: (state, action: PayloadAction<{stateType: 'staff' | 'guest', type: 'userName' | 'pin' | 'email' | 'password', value: string}>) => {
            const { stateType, type, value } = action.payload;
            if(stateType === 'guest') {
                if (type === 'pin') {
                state.loginCredentialGuest.clientPin = value;
                } else {
                    state.loginCredentialGuest.userName = value;
                }
                return;
            }
            if(stateType === 'staff') {
                if (type === 'email') {
                state.loginCredentialStaff.email = value;
                } else {
                    state.loginCredentialStaff.password = value;
                }
                return;
            }
        },
        clearLoginCredential: (state, action: PayloadAction<{type: 'staff' | 'guest'}>) => {
            const { type } = action.payload;
            if(type === 'guest') {
                state.loginCredentialGuest = {
                    userName: '',
                    clientPin: '',
                }
                return
            }
            if(type === 'staff') {
                state.loginCredentialStaff = {
                    email: '',
                    password: '',
                }
            }
        },

        setCredentials: (state, action: PayloadAction<UserCredential>) => {
            state.userCredentials = action.payload;
        },
        logOut: (state, action: PayloadAction<void>) => {
            state.userCredentials = null;
        },
        // setGuestCredentials: ( state, action: PayloadAction<Guest>) => {
        //     state.guest = action.payload;
        // },
        logOutGuest: (state) => {
            state.userCredentials = null;
            // state.guestToken = null;
        },
        resetAuth: (state) => {
            state.userCredentials = null;
            state.loginCredentialGuest = {
                userName: '',
                clientPin: '',
            };
            state.loginCredentialStaff = {
                email: '',
                password: '',
            }
        }
    }
})

export const { 
    setCredentials, 
    logOut, 
    // setGuestCredentials, 
    logOutGuest,

    setLoginCredential,
    clearLoginCredential,
    resetAuth
} = authSlice.actions

export default authSlice.reducer

export const selectCurrentAccessToken = (state: RootState) => state.auth.userCredentials?.accessToken;
export const selectCurrentRefreshToken = (state: RootState) => state.auth.userCredentials?.refreshToken;
export const selectCurrentUser = (state: RootState) => state.auth.userCredentials;
export const selectCurrentGuestGenerateUsername = (state: RootState) => state.auth.userCredentials?.staff.generatedUsername;
export const selectCurrentGuestUsername = (state: RootState) => state.auth.userCredentials?.staff.userName;
export const selectCurrentUserClientID = (state: RootState) => state.auth.userCredentials?.staff.clientID;
export const selectCurrentUserRole = (state: RootState) => state.auth.userCredentials?.staff.role;
export const selectCurrentUserStaffId = (state: RootState) => state.auth.userCredentials?.staff.sessionId;
export const selectCurrentUserGuestId = (state: RootState) => state.auth.userCredentials?.staff.staffID;
export const selectCurrentUserId = (state: RootState) =>
    state.auth.userCredentials?.staff?.sessionId ??
    state.auth.userCredentials?.staff?.staffID;
export const selectCurrentUserName = (state: RootState) => state.auth.userCredentials?.staff.userName;
export const selectCurrentUserFirstName = (state: RootState) => state.auth.userCredentials?.staff.firstName;
// export const selectCurrentGuest = (state: RootState) => state.auth.guest;

export const selectLoginGuest = (state: RootState) => state.auth.loginCredentialGuest;
export const selectLoginGuestName = (state: RootState) => state.auth.loginCredentialGuest.userName;
export const selectLoginGuestPin = (state: RootState) => state.auth.loginCredentialGuest.clientPin;

export const selectLoginStaff = (state: RootState) => state.auth.loginCredentialGuest.clientPin;
export const selectLoginStaffEmail = (state: RootState) => state.auth.loginCredentialStaff.email
export const selectLoginStaffPassword = (state: RootState) => state.auth.loginCredentialStaff.password